/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function() {
  var containerSelector = '[data-cart-discount]';
  var inputSelector = '[data-cart-discount-input]';
  var buttonSelector = '[data-cart-discount-apply]';
  var statusSelector = '[data-cart-discount-status]';

  var getRootPrefix = function() {
    if (window.routes && typeof window.routes.rootUrlWithoutSlash === 'string') {
      return window.routes.rootUrlWithoutSlash;
    }

    return '';
  };

  var parseDiscountResult = function(body, normalizedDiscountCode) {
    var discountCodes;
    var matchedCode = null;

    if (!body || typeof body !== 'object') {
      throw new Error('Could not apply this discount code.');
    }

    discountCodes = Array.isArray(body.discount_codes) ? body.discount_codes : [];

    discountCodes.forEach(function(entry) {
      var entryCode = '';

      if (typeof entry === 'string') {
        entryCode = entry;
      } else if (entry && typeof entry.code === 'string') {
        entryCode = entry.code;
      }

      if (entryCode && entryCode.toUpperCase() === normalizedDiscountCode) {
        matchedCode = entry;
      }
    });

    if (!matchedCode) {
      throw new Error('That discount code is invalid.');
    }

    if (typeof matchedCode === 'object' && matchedCode.applicable === false) {
      throw new Error('That discount code is not applicable.');
    }
  };

  var setStatus = function(container, message, statusType) {
    var statusNode = container ? container.querySelector(statusSelector) : null;

    if (!statusNode) {
      return;
    }

    statusNode.textContent = message || '';
    statusNode.classList.remove('is-error');
    statusNode.classList.remove('is-success');

    if (statusType === 'error') {
      statusNode.classList.add('is-error');
    } else if (statusType === 'success') {
      statusNode.classList.add('is-success');
    }
  };

  var applyDiscountFromContainer = function(container) {
    var inputNode;
    var buttonNode;
    var rawDiscountCode;
    var normalizedDiscountCode;
    var endpoint;

    if (!container) {
      return;
    }

    inputNode = container.querySelector(inputSelector);
    buttonNode = container.querySelector(buttonSelector);

    if (!inputNode || !buttonNode || buttonNode.disabled) {
      return;
    }

    rawDiscountCode = (inputNode.value || '').trim();
    normalizedDiscountCode = rawDiscountCode.toUpperCase();

    if (!rawDiscountCode) {
      setStatus(container, 'Enter a discount code.', 'error');
      inputNode.focus();
      return;
    }

    buttonNode.disabled = true;
    setStatus(container, 'Applying discount...', '');
    endpoint = getRootPrefix() + '/cart/update.js';

    fetch(endpoint, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        discount: rawDiscountCode
      })
    })
      .then(function(response) {
        return response
          .json()
          .catch(function() {
            return null;
          })
          .then(function(body) {
            if (!response.ok) {
              throw new Error((body && (body.description || body.message)) ? (body.description || body.message) : 'Could not apply this discount code.');
            }

            parseDiscountResult(body, normalizedDiscountCode);
            setStatus(container, 'Discount applied.', 'success');
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
            }));
          });
      })
      .catch(function(error) {
        setStatus(container, (error && error.message) ? error.message : 'Could not apply this discount code.', 'error');
      })
      .finally(function() {
        buttonNode.disabled = false;
      });
  };

  document.addEventListener('click', function(event) {
    var applyButton = event.target.closest(buttonSelector);
    var container;

    if (!applyButton) {
      return;
    }

    container = applyButton.closest(containerSelector);
    if (!container) {
      return;
    }

    event.preventDefault();
    applyDiscountFromContainer(container);
  });

  document.addEventListener('keydown', function(event) {
    var inputNode;
    var container;

    if (event.key !== 'Enter') {
      return;
    }

    inputNode = event.target.closest(inputSelector);
    if (!inputNode) {
      return;
    }

    container = inputNode.closest(containerSelector);
    if (!container) {
      return;
    }

    event.preventDefault();
    applyDiscountFromContainer(container);
  });
})();
